module.exports = __webpack_public_path__ + "img/purchase-6.9249a64a.svg";